import * as React from "react";
import styled from "styled-components";

import { media } from "../../common/utils/style";
import { openTwitterShareWindow, openFacebookShareWindow } from "../../common/utils/sns";
import Icon from "../../common/components/Icon";
import { Company } from "../entities";
import CompanyCard from "./campaign/CompanyCard";

interface Props {
  company: Company;
  onClick?: () => void;
  onClose?: () => void;
  className?: string;
}

class CompanyValuesShareMegaphone extends React.PureComponent<Props> {
  public onClickToShare = (target: "facebook" | "twitter") => {
    const url = `https://www.wantedly.com/values?company_id=${this.props.company.id}`;
    if (target === "facebook") {
      openFacebookShareWindow({ url });
    } else {
      openTwitterShareWindow({ url });
    }
    (window as any).logEvent("values_lp:company_megaphone_share_button", "click", { target });
    if (this.props.onClick) {
      this.props.onClick();
    }
  };

  public render() {
    const { company, onClose, className } = this.props;

    return (
      <ShareCompanyWrapper className={className}>
        {onClose && <CloseIcon name="wt-icon-close" onClick={onClose} />}
        <CompanyCardExtended company={company} selectedFeatures={[]} switchDisabled />
        <RightPane>
          <ShareLabel>価値観と一緒に会社をシェアしよう</ShareLabel>
          <ShareDescription>
            選んだ価値観と一緒に、会社の自己紹介をしてみましょう。
            あなたの会社の価値観に興味を持ったユーザーがアプローチしてくれるかもしれません。
          </ShareDescription>
          <ShareButtons>
            <FacebookShareButton onClick={() => this.onClickToShare("facebook")}>Facebookでシェア</FacebookShareButton>
            <TwitterShareButton onClick={() => this.onClickToShare("twitter")}>Twitterでシェア</TwitterShareButton>
          </ShareButtons>
        </RightPane>
      </ShareCompanyWrapper>
    );
  }
}

const CompanyCardExtended = styled(CompanyCard)`
  /* FIXME: Developers keep in mind that the component itself should not include margin */
  margin: 0 !important;
  flex-grow: 0;
  flex-shrink: 0;
  width: 343px;
  @media ${media.medium} {
    width: 308px;
  }
`;

const ShareCompanyWrapper = styled.div`
  display: flex;
  padding: 30px 16px 60px;
  background-color: #fafafa;
  border-radius: 4px;
  position: relative;

  @media ${media.medium} {
    padding: 10px;
  }

  @media ${media.small} {
    flex-direction: column;

    & > ${CompanyCardExtended} {
      margin: auto !important;
    }
  }
`;

const CloseIcon = styled(Icon)`
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 1;
  font-size: 18px;
  color: rgba(0, 0, 0, 0.35);
  cursor: pointer;
  transition: color 100ms;
  &:hover {
    color: rgba(0, 0, 0, 0.6);
  }
`;

const RightPane = styled.div`
  flex-grow: 1;
  flex-shrink: 1;
  padding: 30px 20px 20px 40px;
  position: relative;
  display: flex;
  flex-direction: column;

  @media ${media.small} {
    flex-direction: column;
    padding: 30px 0 0;
  }
`;

const ShareLabel = styled.h4`
  font-weight: 700;
  font-size: 24px;
  line-height: 1.5;
  letter-spacing: 1.3px;
  color: rgba(0, 0, 0, 0.8);
  padding-bottom: 12px;

  @media ${media.small} {
    text-align: center;
    padding-bottom: 18px;
  }
`;

const CompanyPageLink = styled.a`
  display: inline-block;
  text-decoration: none;
  width: 138px;
  height: 33px;
  border-radius: 60px;
  padding: 0 20px;
  font-weight: 600;
  font-size: 13px;
  line-height: 33px;
  text-align: center;
  background-color: #21bddb; /* blue400 */
  color: #ffffff;
  border: none;
  outline: none;
  transition: background-color 0.2s;
  cursor: pointer;

  &:hover {
    background-color: #00aed1; /* blue500 */
    text-decoration: none;
  }
`;

const ShareDescription = styled.p`
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0.8px;
  line-height: 1.71;
  color: rgba(0, 0, 0, 0.56);

  & + ${CompanyPageLink} {
    margin-top: 30px;
  }

  @media ${media.small} {
    font-size: 13px;
    line-height: 1.69;
    letter-spacing: 0.7px;
  }
`;

const ShareButton = styled.button`
  padding: 0;
  width: 245px;
  height: 45px;
  line-height: 45px;
  font-weight: 600;
  font-size: 14px;
  border-radius: 22px;
  border: none;
  text-align: center;
  color: white !important;

  &:focus {
    outline: none;
  }
  @media ${media.medium} {
    width: 185px;
    height: 40px;
    line-height: 40px;
  }
`;

const FacebookShareButton = styled(ShareButton)`
  background-color: rgba(59, 89, 153, 1);
  transition: background-color 100ms;

  &:hover {
    background-color: rgba(59, 89, 153, 0.8);
  }
`;

const TwitterShareButton = styled(ShareButton)`
  margin-top: 10px;
  background-color: rgba(85, 172, 238, 1);
  transition: background-color 100ms;

  &:hover {
    background-color: rgba(85, 172, 238, 0.8);
  }
  @media ${media.medium} {
    margin-top: 0;
    margin-left: 15px;
  }
`;

const ShareButtons = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  align-items: center;
  margin-top: 30px;

  @media ${media.medium} {
    flex-direction: row;
    align-items: unset;
  }
`;

export default CompanyValuesShareMegaphone;



// WEBPACK FOOTER //
// ./frontend/src/company_values/components/CompanyValuesShareMegaphone.tsx